module.exports = __webpack_public_path__ + "static/media/transfer_complete.c42b6d6d.png";